/* ─────────────────────────────────────────────────────────────────────────
   Top nav pill — collapse on scroll.
   Hide (translate up) when scrolling down past a small threshold; reveal on
   scroll up; always reveal at the very end of the page. Mirrors the blog's
   nav-collapse behaviour. Binds to the window scroll position (Lenis does a
   real scroll, so scrollY + scroll events stay accurate).
   ───────────────────────────────────────────────────────────────────────── */
const nav = document.querySelector('[data-nav-collapse]');

if (nav) {
  let last = window.scrollY;
  let hidden = false;

  const set = (hide) => {
    if (hide === hidden) return;
    hidden = hide;
    nav.style.translate = hide ? '0 -120px' : '0 0';
  };

  const onScroll = () => {
    const y = window.scrollY;
    const atEnd = window.innerHeight + y >= document.documentElement.scrollHeight - 4;
    if (atEnd)
      set(false); // always visible at the foot of the page
    else if (y > last && y > 80)
      set(true); // scrolling down
    else if (y < last) set(false); // scrolling up
    last = y;
  };

  window.addEventListener('scroll', onScroll, { passive: true });
}
